import React from "react";
import {
  DetailsListLayoutMode,
  SelectionMode,
  ShimmeredDetailsList,
} from "@fluentui/react";
import type { IColumn } from "@fluentui/react";
import type { TelemetrySummary } from "@/api/telemetry";
import styles from "@/components/telemetry/search/TelemetryTable.module.css";

interface TelemetryTableProps {
  items: TelemetrySummary[];
  columns: IColumn[];
  isLoading: boolean;
  onColumnClick: (column: IColumn) => void;
  onRowClick: (item: TelemetrySummary) => void;
}

function TelemetryTable({
  items,
  columns,
  isLoading,
  onColumnClick,
  onRowClick,
}: TelemetryTableProps) {
  return (
    <div className={styles.container}>
      <ShimmeredDetailsList
        items={items}
        columns={columns}
        layoutMode={DetailsListLayoutMode.justified}
        selectionMode={SelectionMode.none}
        enableShimmer={isLoading}
        shimmerLines={10}
        onColumnHeaderClick={(_, column) => {
          if (column) onColumnClick(column);
        }}
        onActiveItemChanged={(item?: TelemetrySummary) => {
          if (item) onRowClick(item);
        }}
      />
    </div>
  );
}

export default TelemetryTable;
